import { PdfSlicers, ExportStatus } from 'types/pdfExport'

export const initialExportStatus: ExportStatus = {
    completed: false,
    percent: 0,
}

export const slicersQueryParams: Record<keyof PdfSlicers, string> = {
    currencyFilter: 'currency_filter',
    timePeriodFilter: 'time_period_filter',
    startDateFilter: 'start_date_filter',
    endDateFilter: 'end_date_filter',
    subGroupFilters: 'subgroup', // Actual key will be appended with `_{id}_filter` for each subgroup
}
